import type { IFrontendServiceContainer } from '@phi/frontend/service-container';
import type { SessionType } from '../state';
import { add1 } from '@vaaas/fpts/set';

export const authenticate_locally_provider = (app: IFrontendServiceContainer) => () => {
    app.authentication.session_type.value = add1('local' as SessionType)(app.authentication.session_type.value);
    app.pop_under_with_router.hide_pop_under();
    app.state.should_load_app = true;
    app.subscriptions.state.subscription_status.value = 'full';
};
